/**
 * bateclub OAuth config (web, PUBLIC client) - single source of truth.
 *
 * Read by both the browser client (oauth-web-client.ts) and the build-time
 * metadata emitter (scripts/gen-oauth-metadata.js), so `client_id` / `scope` /
 * `redirect_uris` cannot drift.
 *
 * PUBLIC client: `token_endpoint_auth_method: 'none'` -- no private key, no JWKS,
 * no signing service. `client_id` MUST equal the HTTPS URL the metadata document
 * is served at, and the redirect is the site ROOT (callback params are detected
 * at startup in App.web.tsx). Upgradeable to a confidential client later without
 * changing the sign-in UX.
 */

/**
 * The web app's own origin. `client_id` and every `redirect_uri` derive from it.
 * Override per deploy with EXPO_PUBLIC_OAUTH_BASE_URL (Expo inlines EXPO_PUBLIC_*
 * at build). Defaults to the production web origin.
 */
export const OAUTH_BASE_URL: string =
  process.env.EXPO_PUBLIC_OAUTH_BASE_URL || 'https://bateclub.app'

/** Human-facing client name shown on the PDS consent screen. */
export const OAUTH_CLIENT_NAME = 'bateclub'

/**
 * Scope requested at sign-in. `transition:generic` is required so the session
 * can call com.atproto.server.getServiceAuth (used by the video-call feature).
 */
export const OAUTH_SCOPE = 'atproto transition:generic'

/** Handle -> DID resolver the OAuth client uses. A public atproto resolver. */
export const OAUTH_HANDLE_RESOLVER = 'https://bsky.social'

/** The static client-metadata document URL == the atproto client_id. */
export const OAUTH_CLIENT_ID = `${OAUTH_BASE_URL}/oauth-client-metadata.json`

/** The single redirect target: the site root. */
export const OAUTH_REDIRECT_URI = `${OAUTH_BASE_URL}/`
